<template>
    <button
        v-tippy="t('editorToggleHeader5')"
        :class="[
            buttonState(
                editor.can().toggleHeading({ level: 5 }),
                editor.isActive('heading', { level: 5 }),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleHeading({ level: 5 })"
        @click="editor.chain().focus().toggleHeading({ level: 5 }).run()"
    >
        <MdiFormatHeader5 class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatHeader5 from 'materialdesignicons-vue3/icons/MdiFormatHeader5.js';

    defineExpose({
        name: 'FormatHeader5Button',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
